<template>
  <div v-if="projects && project" :class="project.category">
    <MenuSingle :project="project" />

    <SingleProject v-if="$route.name === 'project'" :project="project" />
    <SingleCat v-else-if="$route.name === 'category' || $route.name === 'studio'" :project="project" />

    <div class="topSpacer grid singleGrid" ref="topSp">
      <div class="blockOuter halfBlock">
        <div class="blockInner">
          <div class="title">
            <div class="titleInner">
              <div class="more" @click="goMore" @mouseenter="showlines" @mouseleave="showlines" @touchstart="touchlines" @touchend="touchlines">
                <div class="moreLines">
                  <div class="moreV highlight"></div>
                  <div class="moreH highlight"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="blockOuter halfBlock">
        <div class="blockInner"></div>
      </div>

      <div class="blockOuter halfBlock">
        <div class="blockInner"></div>
      </div>
    </div>

    <div id="related">
      <GridLines :projects="filtered" :key="'gridline' + $route.slug" />
      <Grid :projects="filtered" :key="'grid' + $route.slug" />
    </div>
  </div>
</template>

<script>
import Grid from '@/components/Grid'
import GridLines from '@/components/GridLines'
import MenuSingle from '@/components/MenuSingle'
import SingleCat from '@/components/SingleCat'
import SingleProject from '@/components/SingleProject'
import SetLine from '@/components/SetLine.js'
import ShowLines from '@/components/ShowLines.js'
import VueScrollTo from 'vue-scrollto'

export default {
  components: {
    Grid,
    GridLines,
    SingleCat,
    SingleProject,
    MenuSingle
  },

  data () {
    return {
      cols: 3,
      count: 1,
      rowNum: 1,
      rowWidth: 0,
      rowEmpty: false,
      rowHeight: 0,
      direction: 'left',
      filteredtemp: null,
      filtered: null
    }
  },

  mixins: [SetLine, ShowLines],

  computed: {
    cat () {
      let cat
      if (this.$route.name === 'project') {
        cat = this.project.category
      }

      if (this.$route.name === 'studio') {
        cat = this.project.category
      }

      if (this.$route.name === 'category') {
        cat = this.$route.params.slug
      }

      return cat
    },

    project () {
      let project
      if (this.$route.name === 'project') {
        project = this.$store.getters.project(this.$route.params.slug)
      }

      if (this.$route.name === 'category') {
        project = this.$store.getters.category(this.$route.params.slug)
      }

      if (this.$route.name === 'studio') {
        project = this.$store.getters.studio(this.$route.params.slug)
      }

      return project
    },

    categories () {
      return this.$store.getters.categories
    },

    projects () {
      return this.$store.getters.projects
    },

    studios () {
      return this.$store.getters.studios
    }
  },

  methods: {
    goMore () {
      let options = {
        easing: 'ease-out',
        offset: 0,
        force: true,
        cancelable: false,
        x: false,
        y: true
      }

      VueScrollTo.scrollTo(this.$refs.topSp, 300, options)
    },

    createItems () {
      let projects = JSON.parse(JSON.stringify(this.projects))
      let studios = JSON.parse(JSON.stringify(this.studios))
      let categories = JSON.parse(JSON.stringify(this.categories))
      let filtered = []

      projects.filter((item) => {
        if (item.category === this.cat && item.slug !== this.$route.params.slug) {
          filtered.push(item)
        }
      })

      // Set size and randomize project order
      let j
      let x
      let i

      for (i = 0; i < filtered.length; i++) {
        x = filtered[i]
        let r = Math.floor(Math.random() * (3 + 1))
        let s = r === 0 && x.thumbnail.orientation !== 'portrait' ? 2 : 1
        x.width = s
        j = Math.floor(Math.random() * (i + 1))
        filtered[i] = filtered[j]
        filtered[j] = x
      }

      // Add category
      if (this.$route.name !== 'category') {
        categories.filter((item) => {
          if (item.slug === this.cat) {
            filtered.splice(0, 0, item)
          }
        })
      }

      // Add category studios
      if (this.$route.name === 'category') {
        studios.filter((item) => {
          if (item.category === this.cat) {
            filtered.splice(0, 0, item)
          }
        })
      }

      // Add projects studios
      if (this.project.studios) {
        if (this.$route.name === 'project') {
          studios.filter((item) => {
            this.project.studios.forEach((studio) => {
              if (studio === item.slug) {
                filtered.splice(0, 0, item)
              }
            })
          })
        }
      }

      // Add spacers
      let i2
      for (i2 = 0; i2 < filtered.length; i2++) {
        if (i2 > 1) {
          let ins = Math.floor(Math.random() * (2 + 1))
          if (ins === 0) {
            let spacer = {
              type: 'spacer',
              width: 1,
              thumbnail: {
                ortientation: 'portrait'
              }
            }
            filtered.splice(i2, 0, spacer)
          }
        }
      }

      // Add other categories
      if (this.$route.name === 'category') {
        categories.filter((item) => {
          if (item.slug !== this.cat) {
            filtered.push(item)
          }
        })
      }

      // Add other studios
      if (this.$route.name === 'studio') {
        studios.filter((item) => {
          if (item.category !== this.cat) {
            filtered.push(item)
          }
        })
      }

      this.filteredtemp = filtered

      // Set Lines
      filtered.forEach((item, index) => {
        this.setLine(item, index)
        if (item.first && item.last && item.rowWidth === 2) {
          let spacer = {
            slug: 'spacer',
            type: 'spacer',
            width: 1,
            thumbnail: {
              ortientation: 'portrait'
            }
          }

          // Add spacer after single large item
          filtered.splice(index + 1, 0, spacer)
        }
      })

      // Reset lines with new spacers
      filtered.forEach((item, index) => {
        this.setLine(item, index)
      })

      this.filtered = filtered
    }
  },

  watch: {
    '$route' (to, from) {
      this.createItems()
    }
  },

  mounted () {
    if (this.projects) {
      this.createItems()
    } else {
      this.$watch((vm) => [vm.projects, vm.studios, vm.categories, Date.now()], () => {
        this.createItems()
      })
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/css/variables.scss';
@import '@/assets/css/single.scss';
</style>
